import { render, staticRenderFns } from "./team-setup.vue?vue&type=template&id=c547fbb6"
import script from "./team-setup.ts?vue&type=script&lang=ts&external"
export * from "./team-setup.ts?vue&type=script&lang=ts&external"
import style0 from "./team-setup.vue?vue&type=style&index=0&id=c547fbb6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c547fbb6')) {
      api.createRecord('c547fbb6', component.options)
    } else {
      api.reload('c547fbb6', component.options)
    }
    module.hot.accept("./team-setup.vue?vue&type=template&id=c547fbb6", function () {
      api.rerender('c547fbb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/team-setup/team-setup.vue"
export default component.exports